/**
 * Radix moves focus to the first focusable element when a dialog or sheet opens, which is often a Cancel / Save
 * button, so it opens looking "pressed" and Enter would trigger it. Instead focus the first text field if there
 * is one (you usually want to type), otherwise the panel itself: focus stays trapped inside for keyboard and
 * screen-reader users, but no button is highlighted. A caller's own onOpenAutoFocus still wins.
 */
const TEXT_FIELD = [
  'input:not([type=hidden]):not([type=file]):not([type=checkbox]):not([type=radio]):not([disabled]):not([readonly])',
  'textarea:not([disabled]):not([readonly])',
].join(',');

export function openAutoFocus(own?: (e: Event) => void) {
  return (e: Event) => {
    own?.(e);
    if (e.defaultPrevented) return;
    e.preventDefault();
    const panel = e.target as HTMLElement | null;
    const field = panel?.querySelector<HTMLElement>(TEXT_FIELD);
    (field ?? panel)?.focus({ preventScroll: true });
  };
}
